<template>
    <zen-one
        :showuserinfo="false"
        title="Sistem Hasil Bersepadu Kedah (iHasil)"
        :crumbs="crumbs"
    >
        <z-page title="Kaunter : Senarai Kaunter">
            <w-form ref="dform" @validate="search">
                <w-flex class="mt3">
                    <div class="xs6 mr3">
                        <w-input label="Kod Kaunter"
                            v-model="cari.kaunter_kod"
                        />
                    </div>
                    <div class="xs6 mr3">
                        <z-lookup
                            label="Jabatan"
                            name="jabatan"
                            :url="service_kutipan + 'lookup/jabatan_user'"
                            :sort="false"
                            :cache="false"
                            v-model="cari.jabatan_id"
                        />
                    </div>
                </w-flex>
                <w-flex class="mt3">

                    <div class="xs6 mr3">
                        <w-input label="Keterangan"
                            v-model="cari.kaunter_keterangan"/>
                    </div>

                    <div class="xs6 mr3">
                        <z-lookup
                            label="Jenis Kaunter"
                            name="jenisKaunter"
                            :url="service_kutipan + 'lookup/lkp_kaunter'"
                            :sort="false"
                            :cache="false"
                            v-model="cari.lkp_kaunter_id"
                        />
                    </div>
                </w-flex>
                <w-flex class="mt3">
                </w-flex>
            </w-form>

            <w-flex class="mt1 mb3" justify-end>
                <div class="mt2 text-right">

                    <!-- <w-button
                      bg-color="success"
                      class="mr2"
                      ><w-icon>fal fa-print</w-icon>&nbsp;Cetak</w-button> -->
                    <w-button
                        class="ml1" v-on:click="reset()" bg-color="warning" >
                        <w-icon>fal fa-redo-alt</w-icon>&nbsp;Reset
                    </w-button>

                    <w-button class="ml1" @click="$refs.dform.validate()" :loading="cari.loading">
                        <w-icon>fal fa-search</w-icon>&nbsp;Cari
                    </w-button>
                </div>
            </w-flex>
            <br>
                <center v-if="cari.loading"><w-progress class="ma1" circle></w-progress></center>
            <z-table
                ref="tbluser"
                title="Paparan Senarai Kaunter"
                :headers="table.headers"
                :items="table.items"
                :meta="table.meta"
                class=""
            >

            </z-table>
        </z-page>
    </zen-one>
</template>

<script>
import { reactive } from "vue";
// import ZenOne from '@/Shared/ZenOne'
import ZResource from "@/Modules/z-resource-service";

export default {
    extends: ZResource,
    components: {
        // ZenOne
    },
    props: {
        items: [Array, Object],
    },
    data() {
        return {
            resourceurl: this.service_kutipan + "lkp/kaunter/senarai",
            reload: true,
            form_profil: {},
            crumbs: [
                // { label: this.$page.props.app_name, route: '/sitemap' },
                { label: "iHasil", route: "/" },
                { label: "Kutipan", route: "/kutipan" },
                { label: "Kaunter", route: "/kaunter" },
                { label: "Senarai Kaunter", route: "/Kaunter/senarai" },
            ],
            cari: {
                kaunter_kod: '' ,
                jabatan_id: "",
                kaunter_keterangan :'',
                lkp_kaunter_id :'',
            },
        };
    },
    methods: {
        search() {
            this.cari.loading = true
            this.$inertia.visit(
                window.route('kaunter.senarai') +
                    '?kaunter_kod=' +
                    this.cari.kaunter_kod +
                    '&jabatan_id=' +
                    this.cari.jabatan_id+
                    '&kaunter_keterangan=' +
                    this.cari.kaunter_keterangan+
                    '&lkp_kaunter_id=' +
                    this.cari.lkp_kaunter_id,
                { preserveScroll: true }
            );
        },

        reset() {
            this.cari = {
                kaunter_kod: "",
                jabatan_id: "",
                kaunter_keterangan: "",
                lkp_kaunter_id: "",
            };
            this.search();
        },

    },
    watch: {},
    mounted() {
        // override default setting
        // this.getData();
        this.dialog.width = 900;
        this.cari = location.search
            .slice(1)
            .split("&")
            .map((p) => p.split("="))
            .reduce((obj, [key, value]) => ({ ...obj, [key]: value }), {});
        if (this.cari.kaunter_kod == "undefined") {
            this.cari.kaunter_kod = "";
        }
        if (this.cari.jabatan_id == "undefined") {
            this.cari.jabatan_id = "";
        }
        if (this.cari.kaunter_keterangan == "undefined") {
            this.cari.kaunter_keterangan = "";
        }
        if (this.cari.lkp_kaunter_id == "undefined") {
            this.cari.lkp_kaunter_id = "";
        }
    },
};
</script>
<style>
.w-select__menu {
    z-index: 999999;
}
</style>
